import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'tvcore-progress-container',
    templateUrl: './progress-container.component.html',
    styleUrls: ['./progress-container.component.scss'],
    standalone: false
})
export class ProgressContainerComponent {
	@Input()
	active: number;
	@Input()
	STEP_NAMES: string[];
	@Input()
	STEP_LABEL: string;
	@Input()
	PREVIOUS_LABEL_ON_START: string;
	@Input()
	PREVIOUS_LABEL: string;
	@Input()
	NEXT_LABEL: string;
	@Input()
	FINISH_LABEL: string;
	@Input()
	subtitle: string | null;

	@Output()
	goTo: EventEmitter<number> = new EventEmitter<number>();
	@Output()
	finish: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	next: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	previous: EventEmitter<boolean> = new EventEmitter<boolean>();

	goToClick(step: number) {
		if (step < this.active) {
			this.goTo.next(step);
		}
	}

	finishClick() {
		this.finish.next();
	}

	nextClick() {
		this.next.next();
	}

	previousClick(onStart: boolean = false) {
		this.previous.next(onStart);
	}
}
